import * as React from "react"
const SvgArrowUpRight = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M15.81 9.745 7.904 17.65q-.3.3-.708.3a.97.97 0 0 1-.707-.3q-.3-.3-.3-.707t.3-.708l7.905-7.904-6.93.002a.92.92 0 0 1-.698-.292 1 1 0 0 1-.274-.716q.019-.405.292-.698a.92.92 0 0 1 .698-.292l9.335-.002q.212 0 .38.08.168.079.309.22a.85.85 0 0 1 .22.31q.08.167.08.38l-.002 9.334q0 .39-.292.68a1.02 1.02 0 0 1-.698.31.97.97 0 0 1-.716-.291.97.97 0 0 1-.292-.716l.002-6.895Z" />
  </svg>
)
export default SvgArrowUpRight
